import React from 'react'
import ReactDOM from 'react-dom/client'

import * as Sentry from '@sentry/react'

import { initializeTheming } from '@reown/appkit-ui'

import { App } from './App'

Sentry.init({
  dsn: 'https://3fbc7314ae68d60820cf0fc3e1dab56a@o1095249.ingest.us.sentry.io/4509863926235136',
  sendDefaultPii: false,
  integrations: [
    // Capture console logs as Sentry logs
    Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] }),
    // Enable basic browser tracing (pageloads, XHR/fetch)
    Sentry.browserTracingIntegration()
  ]
})

initializeTheming()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<div>Something went wrong.</div>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
)
